import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import '@/styles/global.css'

// createApp(App).use(router).mount('#app')

const app = createApp(App);
app.use(router);

// this sets all axios requests to send credentials, is needed for cookies
axios.defaults.withCredentials = true;

app.use(VueAxios, axios);
app.mount('#app');
